<script lang="ts">
  import Button from "primevue/button";
  import { useAttrs } from "vue";

  Button.compatConfig = {
    MODE: 3, // full compat
  };

  export default {
    components: { Button },
    inheritAttrs: false,
    compatConfig: {
      MODE: 3,
    },
    setup() {
      const attrs = useAttrs();
      return {
        Button,
        attrs,
      };
    },
  };
</script>

<template>
  <Button v-bind="attrs" />
</template>
